import React from 'react';
interface SummaryCardProps {
  title: string;
  value: string | number;
  icon: React.ReactNode;
  iconBgColor?: string;
  iconColor?: string;
  borderColor?: string;
}
export function SummaryCard({
  title,
  value,
  icon,
  iconBgColor = 'bg-[#00D4FF]/10',
  iconColor = 'text-[#00D4FF]',
  borderColor = 'border-t-[#00D4FF]'
}: SummaryCardProps) {
  return <div className={`bg-[#111827] rounded shadow-lg border border-[#1E3A5F] border-t-2 ${borderColor} p-5 flex items-center space-x-4 hover:glow-cyan transition-all duration-300 relative overflow-hidden group`} data-id="element-84">
      <div className="absolute inset-0 bg-gradient-to-br from-transparent to-[#1A2332] opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none" data-id="element-85"></div>
      <div className={`p-3 rounded ${iconBgColor} ${iconColor} relative z-10 border border-current/20`} data-id="element-86">
        {icon}
      </div>
      <div className="relative z-10" data-id="element-87">
        <p className="text-xs font-semibold text-[#94A3B8] uppercase tracking-wide" data-id="element-88">
          {title}
        </p>
        <h3 className="text-3xl font-bold text-[#E2E8F0] mt-1 font-mono" data-id="element-89">
          {value}
        </h3>
      </div>
    </div>;
}